define('Components/PageHeaderWidget/js/models/PageHeaderAcquisitionModel',['jquery',
    'app',
    'Components/PageHeaderWidget/js/models/PageHeaderWidgetInstanceModel',
  ],
  function ($, app, PageHeaderWidgetInstanceModel) {

    return PageHeaderWidgetInstanceModel.extend({
      name: 'PageHeaderWidgetInstanceModel',
    })
  });
